import { apiGet, GetConsulteePermissionResponse } from 'api';

export const getConsulteePermission = (): Promise<GetConsulteePermissionResponse> =>
  apiGet<GetConsulteePermissionResponse>('consultee/permission');
